import Gtm from "./GTM";

const gtm = new Gtm();

class ToggleCard {
    className: string;
    activeClass: string;
    triggerClass: string;

    constructor() {
        this.className = "toggle-card";
        this.activeClass = "toggle-card--active";
        this.triggerClass = "js-trigger-card-toggle";

        const nodes = [
            ...Array.from(document.getElementsByClassName(this.className)),
        ];
        nodes.forEach((node) => this.addClickEventListener(node));
    }

    addClickEventListener = (node: Element) => {
        const triggers = [
            ...Array.from(node.getElementsByClassName(this.triggerClass)),
        ];
        triggers.forEach((trigger) => {
            trigger.addEventListener("click", this.handleClick(node));
        });
    };

    handleClick = (node: Element) => {
        return () => {
            let open = false;
            if (node.className.indexOf(this.activeClass) >= 0) {
                open = false;
            } else {
                open = true;
            }

            this.resetActiveCards(node);

            if (open) {
                // Open card
                node.classList.add(this.activeClass);
                const topic = node.getElementsByClassName(
                    "toggle-card__heading",
                )
                    ? node.getElementsByClassName("toggle-card__heading")[0]
                          .innerHTML
                    : "";
                gtm.datalayerPush("accordion", { topic });
                node.getElementsByClassName('js-trigger-card-toggle')[0].setAttribute("aria-expanded", "true")
            } else {
                // Close card
                node.classList.remove(this.activeClass);
                node.getElementsByClassName('js-trigger-card-toggle')[0].setAttribute("aria-expanded", "false")
            }
        };
    };

    resetActiveCards = (node: Element) => {
        const cards = [
            ...Array.from(document.getElementsByClassName(this.activeClass)),
        ];
        cards.forEach((card) => this.removeCardActiveState(card));
        node.classList.toggle(this.activeClass);
        return cards;
    };

    removeCardActiveState = (node: Element) => {
        node.classList.remove(this.activeClass);
        return node;
    };
}

export default ToggleCard;
